// extracted by mini-css-extract-plugin
export default {"hero":"home_hero__zvbuC","search-box":"home_search-box__iqIJG","section-title":"home_section-title__qlvJF","rooms-grid":"home_rooms-grid__IhoAD"};